const iconList = [
    ["fas", "ad"],
    ["fas", "address-book"],
    ["fas", "address-card"],
    ["fas", "adjust"],
    ["fas", "air-freshener"],
    ["fas", "align-center"],
    ["fas", "align-justify"],
    ["fas", "align-left"],
    ["fas", "align-right"],
    ["fas", "allergies"],
    ["fas", "ambulance"],
    ["fas", "american-sign-language-interpreting"],
    ["fas", "anchor"],
    ["fas", "angle-double-down"],
    ["fas", "angle-double-left"],
    ["fas", "angle-double-right"],
    ["fas", "angle-double-up"],
    ["fas", "angle-down"],
    ["fas", "angle-left"],
    ["fas", "angle-right"],
    ["fas", "angle-up"],
    ["fas", "angry"],
    ["fas", "ankh"],
    ["fas", "apple-alt"],
    ["fas", "archive"],
    ["fas", "archway"],
    ["fas", "arrow-alt-circle-down"],
    ["fas", "arrow-alt-circle-left"],
    ["fas", "arrow-alt-circle-right"],
    ["fas", "arrow-alt-circle-up"],
    ["fas", "arrow-circle-down"],
    ["fas", "arrow-circle-left"],
    ["fas", "arrow-circle-right"],
    ["fas", "arrow-circle-up"],
    ["fas", "arrow-down"],
    ["fas", "arrow-left"],
    ["fas", "arrow-right"],
    ["fas", "arrow-up"],
    ["fas", "arrows-alt"],
    ["fas", "arrows-alt-h"],
    ["fas", "arrows-alt-v"],
    ["fas", "assistive-listening-systems"],
    ["fas", "asterisk"],
    ["fas", "at"],
    ["fas", "atlas"],
    ["fas", "atom"],
    ["fas", "audio-description"],
    ["fas", "award"],
    ["fas", "baby"],
    ["fas", "baby-carriage"],
    ["fas", "backspace"],
    ["fas", "backward"],
    ["fas", "bacon"],
    ["fas", "bacteria"],
    ["fas", "bacterium"],
    ["fas", "bahai"],
    ["fas", "balance-scale"],
    ["fas", "balance-scale-left"],
    ["fas", "balance-scale-right"],
    ["fas", "ban"],
    ["fas", "band-aid"],
    ["fas", "barcode"],
    ["fas", "bars"],
    ["fas", "baseball-ball"],
    ["fas", "basketball-ball"],
    ["fas", "bath"],
    ["fas", "battery-empty"],
    ["fas", "battery-full"],
    ["fas", "battery-half"],
    ["fas", "battery-quarter"],
    ["fas", "battery-three-quarters"],
    ["fas", "bed"],
    ["fas", "beer"],
    ["fas", "bell"],
    ["fas", "bell-slash"],
    ["fas", "bezier-curve"],
    ["fas", "bible"],
    ["fas", "bicycle"],
    ["fas", "biking"],
    ["fas", "binoculars"],
    ["fas", "biohazard"],
    ["fas", "birthday-cake"],
    ["fas", "blender"],
    ["fas", "blender-phone"],
    ["fas", "blind"],
    ["fas", "blog"],
    ["fas", "bold"],
    ["fas", "bolt"],
    ["fas", "bomb"],
    ["fas", "bone"],
    ["fas", "bong"],
    ["fas", "book"],
    ["fas", "book-dead"],
    ["fas", "book-medical"],
    ["fas", "book-open"],
    ["fas", "book-reader"],
    ["fas", "bookmark"],
    ["fas", "border-all"],
    ["fas", "border-none"],
    ["fas", "border-style"],
    ["fas", "bowling-ball"],
    ["fas", "box"],
    ["fas", "box-open"],
    ["fas", "box-tissue"],
    ["fas", "boxes"],
    ["fas", "braille"],
    ["fas", "brain"],
    ["fas", "bread-slice"],
    ["fas", "briefcase"],
    ["fas", "briefcase-medical"],
    ["fas", "broadcast-tower"],
    ["fas", "broom"],
    ["fas", "brush"],
    ["fas", "bug"],
    ["fas", "building"],
    ["fas", "bullhorn"],
    ["fas", "bullseye"],
    ["fas", "burn"],
    ["fas", "bus"],
    ["fas", "bus-alt"],
    ["fas", "business-time"],
    ["fas", "calculator"],
    ["fas", "calendar"],
    ["fas", "calendar-alt"],
    ["fas", "calendar-check"],
    ["fas", "calendar-day"],
    ["fas", "calendar-minus"],
    ["fas", "calendar-plus"],
    ["fas", "calendar-times"],
    ["fas", "calendar-week"],
    ["fas", "camera"],
    ["fas", "camera-retro"],
    ["fas", "campground"],
    ["fas", "candy-cane"],
    ["fas", "cannabis"],
    ["fas", "capsules"],
    ["fas", "car"],
    ["fas", "car-alt"],
    ["fas", "car-battery"],
    ["fas", "car-crash"],
    ["fas", "car-side"],
    ["fas", "caravan"],
    ["fas", "caret-down"],
    ["fas", "caret-left"],
    ["fas", "caret-right"],
    ["fas", "caret-square-down"],
    ["fas", "caret-square-left"],
    ["fas", "caret-square-right"],
    ["fas", "caret-square-up"],
    ["fas", "caret-up"],
    ["fas", "carrot"],
    ["fas", "cart-arrow-down"],
    ["fas", "cart-plus"],
    ["fas", "cash-register"],
    ["fas", "cat"],
    ["fas", "certificate"],
    ["fas", "chair"],
    ["fas", "chalkboard"],
    ["fas", "chalkboard-teacher"],
    ["fas", "charging-station"],
    ["fas", "chart-area"],
    ["fas", "chart-bar"],
    ["fas", "chart-line"],
    ["fas", "chart-pie"],
    ["fas", "check"],
    ["fas", "check-circle"],
    ["fas", "check-double"],
    ["fas", "check-square"],
    ["fas", "cheese"],
    ["fas", "chess"],
    ["fas", "chess-bishop"],
    ["fas", "chess-board"],
    ["fas", "chess-king"],
    ["fas", "chess-knight"],
    ["fas", "chess-pawn"],
    ["fas", "chess-queen"],
    ["fas", "chess-rook"],
    ["fas", "chevron-circle-down"],
    ["fas", "chevron-circle-left"],
    ["fas", "chevron-circle-right"],
    ["fas", "chevron-circle-up"],
    ["fas", "chevron-down"],
    ["fas", "chevron-left"],
    ["fas", "chevron-right"],
    ["fas", "chevron-up"],
    ["fas", "child"],
    ["fas", "church"],
    ["fas", "circle"],
    ["fas", "circle-notch"],
    ["fas", "city"],
    ["fas", "clinic-medical"],
    ["fas", "clipboard"],
    ["fas", "clipboard-check"],
    ["fas", "clipboard-list"],
    ["fas", "clock"],
    ["fas", "clone"],
    ["fas", "closed-captioning"],
    ["fas", "cloud"],
    ["fas", "cloud-download-alt"],
    ["fas", "cloud-meatball"],
    ["fas", "cloud-moon"],
    ["fas", "cloud-moon-rain"],
    ["fas", "cloud-rain"],
    ["fas", "cloud-showers-heavy"],
    ["fas", "cloud-sun"],
    ["fas", "cloud-sun-rain"],
    ["fas", "cloud-upload-alt"],
    ["fas", "cocktail"],
    ["fas", "code"],
    ["fas", "code-branch"],
    ["fas", "coffee"],
    ["fas", "cog"],
    ["fas", "cogs"],
    ["fas", "coins"],
    ["fas", "columns"],
    ["fas", "comment"],
    ["fas", "comment-alt"],
    ["fas", "comment-dollar"],
    ["fas", "comment-dots"],
    ["fas", "comment-medical"],
    ["fas", "comment-slash"],
    ["fas", "comments"],
    ["fas", "comments-dollar"],
    ["fas", "compact-disc"],
    ["fas", "compass"],
    ["fas", "compress"],
    ["fas", "compress-alt"],
    ["fas", "compress-arrows-alt"],
    ["fas", "concierge-bell"],
    ["fas", "cookie"],
    ["fas", "cookie-bite"],
    ["fas", "copy"],
    ["fas", "copyright"],
    ["fas", "couch"],
    ["fas", "credit-card"],
    ["fas", "crop"],
    ["fas", "crop-alt"],
    ["fas", "cross"],
    ["fas", "crosshairs"],
    ["fas", "crow"],
    ["fas", "crown"],
    ["fas", "crutch"],
    ["fas", "cube"],
    ["fas", "cubes"],
    ["fas", "cut"],
    ["fas", "database"],
    ["fas", "deaf"],
    ["fas", "democrat"],
    ["fas", "desktop"],
    ["fas", "dharmachakra"],
    ["fas", "diagnoses"],
    ["fas", "dice"],
    ["fas", "dice-d20"],
    ["fas", "dice-d6"],
    ["fas", "dice-five"],
    ["fas", "dice-four"],
    ["fas", "dice-one"],
    ["fas", "dice-six"],
    ["fas", "dice-three"],
    ["fas", "dice-two"],
    ["fas", "digital-tachograph"],
    ["fas", "directions"],
    ["fas", "disease"],
    ["fas", "divide"],
    ["fas", "dizzy"],
    ["fas", "dna"],
    ["fas", "dog"],
    ["fas", "dollar-sign"],
    ["fas", "dolly"],
    ["fas", "dolly-flatbed"],
    ["fas", "donate"],
    ["fas", "door-closed"],
    ["fas", "door-open"],
    ["fas", "dot-circle"],
    ["fas", "dove"],
    ["fas", "download"],
    ["fas", "drafting-compass"],
    ["fas", "dragon"],
    ["fas", "draw-polygon"],
    ["fas", "drum"],
    ["fas", "drum-steelpan"],
    ["fas", "drumstick-bite"],
    ["fas", "dumbbell"],
    ["fas", "dumpster"],
    ["fas", "dumpster-fire"],
    ["fas", "dungeon"],
    ["fas", "edit"],
    ["fas", "egg"],
    ["fas", "eject"],
    ["fas", "ellipsis-h"],
    ["fas", "ellipsis-v"],
    ["fas", "envelope"],
    ["fas", "envelope-open"],
    ["fas", "envelope-open-text"],
    ["fas", "envelope-square"],
    ["fas", "equals"],
    ["fas", "eraser"],
    ["fas", "ethernet"],
    ["fas", "euro-sign"],
    ["fas", "exchange-alt"],
    ["fas", "exclamation"],
    ["fas", "exclamation-circle"],
    ["fas", "exclamation-triangle"],
    ["fas", "expand"],
    ["fas", "expand-alt"],
    ["fas", "expand-arrows-alt"],
    ["fas", "external-link-alt"],
    ["fas", "external-link-square-alt"],
    ["fas", "eye"],
    ["fas", "eye-dropper"],
    ["fas", "eye-slash"],
    ["fas", "fan"],
    ["fas", "fast-backward"],
    ["fas", "fast-forward"],
    ["fas", "faucet"],
    ["fas", "fax"],
    ["fas", "feather"],
    ["fas", "feather-alt"],
    ["fas", "female"],
    ["fas", "fighter-jet"],
    ["fas", "file"],
    ["fas", "file-alt"],
    ["fas", "file-archive"],
    ["fas", "file-audio"],
    ["fas", "file-code"],
    ["fas", "file-contract"],
    ["fas", "file-csv"],
    ["fas", "file-download"],
    ["fas", "file-excel"],
    ["fas", "file-export"],
    ["fas", "file-image"],
    ["fas", "file-import"],
    ["fas", "file-invoice"],
    ["fas", "file-invoice-dollar"],
    ["fas", "file-medical"],
    ["fas", "file-medical-alt"],
    ["fas", "file-pdf"],
    ["fas", "file-powerpoint"],
    ["fas", "file-prescription"],
    ["fas", "file-signature"],
    ["fas", "file-upload"],
    ["fas", "file-video"],
    ["fas", "file-word"],
    ["fas", "fill"],
    ["fas", "fill-drip"],
    ["fas", "film"],
    ["fas", "filter"],
    ["fas", "fingerprint"],
    ["fas", "fire"],
    ["fas", "fire-alt"],
    ["fas", "fire-extinguisher"],
    ["fas", "first-aid"],
    ["fas", "fish"],
    ["fas", "fist-raised"],
    ["fas", "flag"],
    ["fas", "flag-checkered"],
    ["fas", "flag-usa"],
    ["fas", "flask"],
    ["fas", "flushed"],
    ["fas", "folder"],
    ["fas", "folder-minus"],
    ["fas", "folder-open"],
    ["fas", "folder-plus"],
    ["fas", "font"],
    ["fas", "font-awesome-logo-full"],
    ["fas", "football-ball"],
    ["fas", "forward"],
    ["fas", "frog"],
    ["fas", "frown"],
    ["fas", "frown-open"],
    ["fas", "funnel-dollar"],
    ["fas", "futbol"],
    ["fas", "gamepad"],
    ["fas", "gas-pump"],
    ["fas", "gavel"],
    ["fas", "gem"],
    ["fas", "genderless"],
    ["fas", "ghost"],
    ["fas", "gift"],
    ["fas", "gifts"],
    ["fas", "glass-cheers"],
    ["fas", "glass-martini"],
    ["fas", "glass-martini-alt"],
    ["fas", "glass-whiskey"],
    ["fas", "glasses"],
    ["fas", "globe"],
    ["fas", "globe-africa"],
    ["fas", "globe-americas"],
    ["fas", "globe-asia"],
    ["fas", "globe-europe"],
    ["fas", "golf-ball"],
    ["fas", "gopuram"],
    ["fas", "graduation-cap"],
    ["fas", "greater-than"],
    ["fas", "greater-than-equal"],
    ["fas", "grimace"],
    ["fas", "grin"],
    ["fas", "grin-alt"],
    ["fas", "grin-beam"],
    ["fas", "grin-beam-sweat"],
    ["fas", "grin-hearts"],
    ["fas", "grin-squint"],
    ["fas", "grin-squint-tears"],
    ["fas", "grin-stars"],
    ["fas", "grin-tears"],
    ["fas", "grin-tongue"],
    ["fas", "grin-tongue-squint"],
    ["fas", "grin-tongue-wink"],
    ["fas", "grin-wink"],
    ["fas", "grip-horizontal"],
    ["fas", "grip-lines"],
    ["fas", "grip-lines-vertical"],
    ["fas", "grip-vertical"],
    ["fas", "guitar"],
    ["fas", "h-square"],
    ["fas", "hamburger"],
    ["fas", "hammer"],
    ["fas", "hamsa"],
    ["fas", "hand-holding"],
    ["fas", "hand-holding-heart"],
    ["fas", "hand-holding-medical"],
    ["fas", "hand-holding-usd"],
    ["fas", "hand-holding-water"],
    ["fas", "hand-lizard"],
    ["fas", "hand-middle-finger"],
    ["fas", "hand-paper"],
    ["fas", "hand-peace"],
    ["fas", "hand-point-down"],
    ["fas", "hand-point-left"],
    ["fas", "hand-point-right"],
    ["fas", "hand-point-up"],
    ["fas", "hand-pointer"],
    ["fas", "hand-rock"],
    ["fas", "hand-scissors"],
    ["fas", "hand-sparkles"],
    ["fas", "hand-spock"],
    ["fas", "hands"],
    ["fas", "hands-helping"],
    ["fas", "hands-wash"],
    ["fas", "handshake"],
    ["fas", "handshake-alt-slash"],
    ["fas", "handshake-slash"],
    ["fas", "hanukiah"],
    ["fas", "hard-hat"],
    ["fas", "hashtag"],
    ["fas", "hat-cowboy"],
    ["fas", "hat-cowboy-side"],
    ["fas", "hat-wizard"],
    ["fas", "hdd"],
    ["fas", "head-side-cough"],
    ["fas", "head-side-cough-slash"],
    ["fas", "head-side-mask"],
    ["fas", "head-side-virus"],
    ["fas", "heading"],
    ["fas", "headphones"],
    ["fas", "headphones-alt"],
    ["fas", "headset"],
    ["fas", "heart"],
    ["fas", "heart-broken"],
    ["fas", "heartbeat"],
    ["fas", "helicopter"],
    ["fas", "highlighter"],
    ["fas", "hiking"],
    ["fas", "hippo"],
    ["fas", "history"],
    ["fas", "hockey-puck"],
    ["fas", "holly-berry"],
    ["fas", "home"],
    ["fas", "horse"],
    ["fas", "horse-head"],
    ["fas", "hospital"],
    ["fas", "hospital-alt"],
    ["fas", "hospital-symbol"],
    ["fas", "hospital-user"],
    ["fas", "hot-tub"],
    ["fas", "hotdog"],
    ["fas", "hotel"],
    ["fas", "hourglass"],
    ["fas", "hourglass-end"],
    ["fas", "hourglass-half"],
    ["fas", "hourglass-start"],
    ["fas", "house-damage"],
    ["fas", "house-user"],
    ["fas", "hryvnia"],
    ["fas", "i-cursor"],
    ["fas", "ice-cream"],
    ["fas", "icicles"],
    ["fas", "icons"],
    ["fas", "id-badge"],
    ["fas", "id-card"],
    ["fas", "id-card-alt"],
    ["fas", "igloo"],
    ["fas", "image"],
    ["fas", "images"],
    ["fas", "inbox"],
    ["fas", "indent"],
    ["fas", "industry"],
    ["fas", "infinity"],
    ["fas", "info"],
    ["fas", "info-circle"],
    ["fas", "italic"],
    ["fas", "jedi"],
    ["fas", "joint"],
    ["fas", "journal-whills"],
    ["fas", "kaaba"],
    ["fas", "key"],
    ["fas", "keyboard"],
    ["fas", "khanda"],
    ["fas", "kiss"],
    ["fas", "kiss-beam"],
    ["fas", "kiss-wink-heart"],
    ["fas", "kiwi-bird"],
    ["fas", "landmark"],
    ["fas", "language"],
    ["fas", "laptop"],
    ["fas", "laptop-code"],
    ["fas", "laptop-house"],
    ["fas", "laptop-medical"],
    ["fas", "laugh"],
    ["fas", "laugh-beam"],
    ["fas", "laugh-squint"],
    ["fas", "laugh-wink"],
    ["fas", "layer-group"],
    ["fas", "leaf"],
    ["fas", "lemon"],
    ["fas", "less-than"],
    ["fas", "less-than-equal"],
    ["fas", "level-down-alt"],
    ["fas", "level-up-alt"],
    ["fas", "life-ring"],
    ["fas", "lightbulb"],
    ["fas", "link"],
    ["fas", "lira-sign"],
    ["fas", "list"],
    ["fas", "list-alt"],
    ["fas", "list-ol"],
    ["fas", "list-ul"],
    ["fas", "location-arrow"],
    ["fas", "lock"],
    ["fas", "lock-open"],
    ["fas", "long-arrow-alt-down"],
    ["fas", "long-arrow-alt-left"],
    ["fas", "long-arrow-alt-right"],
    ["fas", "long-arrow-alt-up"],
    ["fas", "low-vision"],
    ["fas", "luggage-cart"],
    ["fas", "lungs"],
    ["fas", "lungs-virus"],
    ["fas", "magic"],
    ["fas", "magnet"],
    ["fas", "mail-bulk"],
    ["fas", "male"],
    ["fas", "map"],
    ["fas", "map-marked"],
    ["fas", "map-marked-alt"],
    ["fas", "map-marker"],
    ["fas", "map-marker-alt"],
    ["fas", "map-pin"],
    ["fas", "map-signs"],
    ["fas", "marker"],
    ["fas", "mars"],
    ["fas", "mars-double"],
    ["fas", "mars-stroke"],
    ["fas", "mars-stroke-h"],
    ["fas", "mars-stroke-v"],
    ["fas", "mask"],
    ["fas", "medal"],
    ["fas", "medkit"],
    ["fas", "meh"],
    ["fas", "meh-blank"],
    ["fas", "meh-rolling-eyes"],
    ["fas", "memory"],
    ["fas", "menorah"],
    ["fas", "mercury"],
    ["fas", "meteor"],
    ["fas", "microchip"],
    ["fas", "microphone"],
    ["fas", "microphone-alt"],
    ["fas", "microphone-alt-slash"],
    ["fas", "microphone-slash"],
    ["fas", "microscope"],
    ["fas", "minus"],
    ["fas", "minus-circle"],
    ["fas", "minus-square"],
    ["fas", "mitten"],
    ["fas", "mobile"],
    ["fas", "mobile-alt"],
    ["fas", "money-bill"],
    ["fas", "money-bill-alt"],
    ["fas", "money-bill-wave"],
    ["fas", "money-bill-wave-alt"],
    ["fas", "money-check"],
    ["fas", "money-check-alt"],
    ["fas", "monument"],
    ["fas", "moon"],
    ["fas", "mortar-pestle"],
    ["fas", "mosque"],
    ["fas", "motorcycle"],
    ["fas", "mountain"],
    ["fas", "mouse"],
    ["fas", "mouse-pointer"],
    ["fas", "mug-hot"],
    ["fas", "music"],
    ["fas", "network-wired"],
    ["fas", "neuter"],
    ["fas", "newspaper"],
    ["fas", "not-equal"],
    ["fas", "notes-medical"],
    ["fas", "object-group"],
    ["fas", "object-ungroup"],
    ["fas", "oil-can"],
    ["fas", "om"],
    ["fas", "otter"],
    ["fas", "outdent"],
    ["fas", "pager"],
    ["fas", "paint-brush"],
    ["fas", "paint-roller"],
    ["fas", "palette"],
    ["fas", "pallet"],
    ["fas", "paper-plane"],
    ["fas", "paperclip"],
    ["fas", "parachute-box"],
    ["fas", "paragraph"],
    ["fas", "parking"],
    ["fas", "passport"],
    ["fas", "pastafarianism"],
    ["fas", "paste"],
    ["fas", "pause"],
    ["fas", "pause-circle"],
    ["fas", "paw"],
    ["fas", "peace"],
    ["fas", "pen"],
    ["fas", "pen-alt"],
    ["fas", "pen-fancy"],
    ["fas", "pen-nib"],
    ["fas", "pen-square"],
    ["fas", "pencil-alt"],
    ["fas", "pencil-ruler"],
    ["fas", "people-arrows"],
    ["fas", "people-carry"],
    ["fas", "pepper-hot"],
    ["fas", "percent"],
    ["fas", "percentage"],
    ["fas", "person-booth"],
    ["fas", "phone"],
    ["fas", "phone-alt"],
    ["fas", "phone-slash"],
    ["fas", "phone-square"],
    ["fas", "phone-square-alt"],
    ["fas", "phone-volume"],
    ["fas", "photo-video"],
    ["fas", "piggy-bank"],
    ["fas", "pills"],
    ["fas", "pizza-slice"],
    ["fas", "place-of-worship"],
    ["fas", "plane"],
    ["fas", "plane-arrival"],
    ["fas", "plane-departure"],
    ["fas", "plane-slash"],
    ["fas", "play"],
    ["fas", "play-circle"],
    ["fas", "plug"],
    ["fas", "plus"],
    ["fas", "plus-circle"],
    ["fas", "plus-square"],
    ["fas", "podcast"],
    ["fas", "poll"],
    ["fas", "poll-h"],
    ["fas", "poo"],
    ["fas", "poo-storm"],
    ["fas", "poop"],
    ["fas", "portrait"],
    ["fas", "pound-sign"],
    ["fas", "power-off"],
    ["fas", "pray"],
    ["fas", "praying-hands"],
    ["fas", "prescription"],
    ["fas", "prescription-bottle"],
    ["fas", "prescription-bottle-alt"],
    ["fas", "print"],
    ["fas", "procedures"],
    ["fas", "project-diagram"],
    ["fas", "pump-medical"],
    ["fas", "pump-soap"],
    ["fas", "puzzle-piece"],
    ["fas", "qrcode"],
    ["fas", "question"],
    ["fas", "question-circle"],
    ["fas", "quidditch"],
    ["fas", "quote-left"],
    ["fas", "quote-right"],
    ["fas", "quran"],
    ["fas", "radiation"],
    ["fas", "radiation-alt"],
    ["fas", "rainbow"],
    ["fas", "random"],
    ["fas", "receipt"],
    ["fas", "record-vinyl"],
    ["fas", "recycle"],
    ["fas", "redo"],
    ["fas", "redo-alt"],
    ["fas", "registered"],
    ["fas", "remove-format"],
    ["fas", "reply"],
    ["fas", "reply-all"],
    ["fas", "republican"],
    ["fas", "restroom"],
    ["fas", "retweet"],
    ["fas", "ribbon"],
    ["fas", "ring"],
    ["fas", "road"],
    ["fas", "robot"],
    ["fas", "rocket"],
    ["fas", "route"],
    ["fas", "rss"],
    ["fas", "rss-square"],
    ["fas", "ruble-sign"],
    ["fas", "ruler"],
    ["fas", "ruler-combined"],
    ["fas", "ruler-horizontal"],
    ["fas", "ruler-vertical"],
    ["fas", "running"],
    ["fas", "rupee-sign"],
    ["fas", "sad-cry"],
    ["fas", "sad-tear"],
    ["fas", "satellite"],
    ["fas", "satellite-dish"],
    ["fas", "save"],
    ["fas", "school"],
    ["fas", "screwdriver"],
    ["fas", "scroll"],
    ["fas", "sd-card"],
    ["fas", "search"],
    ["fas", "search-dollar"],
    ["fas", "search-location"],
    ["fas", "search-minus"],
    ["fas", "search-plus"],
    ["fas", "seedling"],
    ["fas", "server"],
    ["fas", "shapes"],
    ["fas", "share"],
    ["fas", "share-alt"],
    ["fas", "share-alt-square"],
    ["fas", "share-square"],
    ["fas", "shekel-sign"],
    ["fas", "shield-alt"],
    ["fas", "shield-virus"],
    ["fas", "ship"],
    ["fas", "shipping-fast"],
    ["fas", "shoe-prints"],
    ["fas", "shopping-bag"],
    ["fas", "shopping-basket"],
    ["fas", "shopping-cart"],
    ["fas", "shower"],
    ["fas", "shuttle-van"],
    ["fas", "sign"],
    ["fas", "sign-in-alt"],
    ["fas", "sign-language"],
    ["fas", "sign-out-alt"],
    ["fas", "signal"],
    ["fas", "signature"],
    ["fas", "sim-card"],
    ["fas", "sink"],
    ["fas", "sitemap"],
    ["fas", "skating"],
    ["fas", "skiing"],
    ["fas", "skiing-nordic"],
    ["fas", "skull"],
    ["fas", "skull-crossbones"],
    ["fas", "slash"],
    ["fas", "sleigh"],
    ["fas", "sliders-h"],
    ["fas", "smile"],
    ["fas", "smile-beam"],
    ["fas", "smile-wink"],
    ["fas", "smog"],
    ["fas", "smoking"],
    ["fas", "smoking-ban"],
    ["fas", "sms"],
    ["fas", "snowboarding"],
    ["fas", "snowflake"],
    ["fas", "snowman"],
    ["fas", "snowplow"],
    ["fas", "soap"],
    ["fas", "socks"],
    ["fas", "solar-panel"],
    ["fas", "sort"],
    ["fas", "sort-alpha-down"],
    ["fas", "sort-alpha-down-alt"],
    ["fas", "sort-alpha-up"],
    ["fas", "sort-alpha-up-alt"],
    ["fas", "sort-amount-down"],
    ["fas", "sort-amount-down-alt"],
    ["fas", "sort-amount-up"],
    ["fas", "sort-amount-up-alt"],
    ["fas", "sort-down"],
    ["fas", "sort-numeric-down"],
    ["fas", "sort-numeric-down-alt"],
    ["fas", "sort-numeric-up"],
    ["fas", "sort-numeric-up-alt"],
    ["fas", "sort-up"],
    ["fas", "spa"],
    ["fas", "space-shuttle"],
    ["fas", "spell-check"],
    ["fas", "spider"],
    ["fas", "spinner"],
    ["fas", "splotch"],
    ["fas", "spray-can"],
    ["fas", "square"],
    ["fas", "square-full"],
    ["fas", "square-root-alt"],
    ["fas", "stamp"],
    ["fas", "star"],
    ["fas", "star-and-crescent"],
    ["fas", "star-half"],
    ["fas", "star-half-alt"],
    ["fas", "star-of-david"],
    ["fas", "star-of-life"],
    ["fas", "step-backward"],
    ["fas", "step-forward"],
    ["fas", "stethoscope"],
    ["fas", "sticky-note"],
    ["fas", "stop"],
    ["fas", "stop-circle"],
    ["fas", "stopwatch"],
    ["fas", "stopwatch-20"],
    ["fas", "store"],
    ["fas", "store-alt"],
    ["fas", "store-alt-slash"],
    ["fas", "store-slash"],
    ["fas", "stream"],
    ["fas", "street-view"],
    ["fas", "strikethrough"],
    ["fas", "stroopwafel"],
    ["fas", "subscript"],
    ["fas", "subway"],
    ["fas", "suitcase"],
    ["fas", "suitcase-rolling"],
    ["fas", "sun"],
    ["fas", "superscript"],
    ["fas", "surprise"],
    ["fas", "swatchbook"],
    ["fas", "swimmer"],
    ["fas", "swimming-pool"],
    ["fas", "synagogue"],
    ["fas", "sync"],
    ["fas", "sync-alt"],
    ["fas", "syringe"],
    ["fas", "table"],
    ["fas", "table-tennis"],
    ["fas", "tablet"],
    ["fas", "tablet-alt"],
    ["fas", "tablets"],
    ["fas", "tachometer-alt"],
    ["fas", "tag"],
    ["fas", "tags"],
    ["fas", "tape"],
    ["fas", "tasks"],
    ["fas", "taxi"],
    ["fas", "teeth"],
    ["fas", "teeth-open"],
    ["fas", "temperature-high"],
    ["fas", "temperature-low"],
    ["fas", "tenge"],
    ["fas", "terminal"],
    ["fas", "text-height"],
    ["fas", "text-width"],
    ["fas", "th"],
    ["fas", "th-large"],
    ["fas", "th-list"],
    ["fas", "theater-masks"],
    ["fas", "thermometer"],
    ["fas", "thermometer-empty"],
    ["fas", "thermometer-full"],
    ["fas", "thermometer-half"],
    ["fas", "thermometer-quarter"],
    ["fas", "thermometer-three-quarters"],
    ["fas", "thumbs-down"],
    ["fas", "thumbs-up"],
    ["fas", "thumbtack"],
    ["fas", "ticket-alt"],
    ["fas", "times"],
    ["fas", "times-circle"],
    ["fas", "tint"],
    ["fas", "tint-slash"],
    ["fas", "tired"],
    ["fas", "toggle-off"],
    ["fas", "toggle-on"],
    ["fas", "toilet"],
    ["fas", "toilet-paper"],
    ["fas", "toilet-paper-slash"],
    ["fas", "toolbox"],
    ["fas", "tools"],
    ["fas", "tooth"],
    ["fas", "torah"],
    ["fas", "torii-gate"],
    ["fas", "tractor"],
    ["fas", "trademark"],
    ["fas", "traffic-light"],
    ["fas", "trailer"],
    ["fas", "train"],
    ["fas", "tram"],
    ["fas", "transgender"],
    ["fas", "transgender-alt"],
    ["fas", "trash"],
    ["fas", "trash-alt"],
    ["fas", "trash-restore"],
    ["fas", "trash-restore-alt"],
    ["fas", "tree"],
    ["fas", "trophy"],
    ["fas", "truck"],
    ["fas", "truck-loading"],
    ["fas", "truck-monster"],
    ["fas", "truck-moving"],
    ["fas", "truck-pickup"],
    ["fas", "tshirt"],
    ["fas", "tty"],
    ["fas", "tv"],
    ["fas", "umbrella"],
    ["fas", "umbrella-beach"],
    ["fas", "underline"],
    ["fas", "undo"],
    ["fas", "undo-alt"],
    ["fas", "universal-access"],
    ["fas", "university"],
    ["fas", "unlink"],
    ["fas", "unlock"],
    ["fas", "unlock-alt"],
    ["fas", "upload"],
    ["fas", "user"],
    ["fas", "user-alt"],
    ["fas", "user-alt-slash"],
    ["fas", "user-astronaut"],
    ["fas", "user-check"],
    ["fas", "user-circle"],
    ["fas", "user-clock"],
    ["fas", "user-cog"],
    ["fas", "user-edit"],
    ["fas", "user-friends"],
    ["fas", "user-graduate"],
    ["fas", "user-injured"],
    ["fas", "user-lock"],
    ["fas", "user-md"],
    ["fas", "user-minus"],
    ["fas", "user-ninja"],
    ["fas", "user-nurse"],
    ["fas", "user-plus"],
    ["fas", "user-secret"],
    ["fas", "user-shield"],
    ["fas", "user-slash"],
    ["fas", "user-tag"],
    ["fas", "user-tie"],
    ["fas", "user-times"],
    ["fas", "users"],
    ["fas", "users-cog"],
    ["fas", "users-slash"],
    ["fas", "utensil-spoon"],
    ["fas", "utensils"],
    ["fas", "vector-square"],
    ["fas", "venus"],
    ["fas", "venus-double"],
    ["fas", "venus-mars"],
    ["fas", "vial"],
    ["fas", "vials"],
    ["fas", "video"],
    ["fas", "video-slash"],
    ["fas", "vihara"],
    ["fas", "virus"],
    ["fas", "virus-slash"],
    ["fas", "viruses"],
    ["fas", "voicemail"],
    ["fas", "volleyball-ball"],
    ["fas", "volume-down"],
    ["fas", "volume-mute"],
    ["fas", "volume-off"],
    ["fas", "volume-up"],
    ["fas", "vote-yea"],
    ["fas", "vr-cardboard"],
    ["fas", "walking"],
    ["fas", "wallet"],
    ["fas", "warehouse"],
    ["fas", "water"],
    ["fas", "wave-square"],
    ["fas", "weight"],
    ["fas", "weight-hanging"],
    ["fas", "wheelchair"],
    ["fas", "wifi"],
    ["fas", "wind"],
    ["fas", "window-close"],
    ["fas", "window-maximize"],
    ["fas", "window-minimize"],
    ["fas", "window-restore"],
    ["fas", "wine-bottle"],
    ["fas", "wine-glass"],
    ["fas", "wine-glass-alt"],
    ["fas", "won-sign"],
    ["fas", "wrench"],
    ["fas", "x-ray"],
    ["fas", "yen-sign"],
    ["fas", "yin-yang"],
    ["fab", "500px"],
    ["fab", "accessible-icon"],
    ["fab", "accusoft"],
    ["fab", "acquisitions-incorporated"],
    ["fab", "adn"],
    ["fab", "adobe"],
    ["fab", "adversal"],
    ["fab", "affiliatetheme"],
    ["fab", "airbnb"],
    ["fab", "algolia"],
    ["fab", "alipay"],
    ["fab", "amazon"],
    ["fab", "amazon-pay"],
    ["fab", "amilia"],
    ["fab", "android"],
    ["fab", "angellist"],
    ["fab", "angrycreative"],
    ["fab", "angular"],
    ["fab", "app-store"],
    ["fab", "app-store-ios"],
    ["fab", "apper"],
    ["fab", "apple"],
    ["fab", "apple-pay"],
    ["fab", "artstation"],
    ["fab", "asymmetrik"],
    ["fab", "atlassian"],
    ["fab", "audible"],
    ["fab", "autoprefixer"],
    ["fab", "avianex"],
    ["fab", "aviato"],
    ["fab", "aws"],
    ["fab", "bandcamp"],
    ["fab", "battle-net"],
    ["fab", "behance"],
    ["fab", "behance-square"],
    ["fab", "bimobject"],
    ["fab", "bitbucket"],
    ["fab", "bitcoin"],
    ["fab", "bity"],
    ["fab", "black-tie"],
    ["fab", "blackberry"],
    ["fab", "blogger"],
    ["fab", "blogger-b"],
    ["fab", "bluetooth"],
    ["fab", "bluetooth-b"],
    ["fab", "bootstrap"],
    ["fab", "btc"],
    ["fab", "buffer"],
    ["fab", "buromobelexperte"],
    ["fab", "buy-n-large"],
    ["fab", "buysellads"],
    ["fab", "canadian-maple-leaf"],
    ["fab", "cc-amazon-pay"],
    ["fab", "cc-amex"],
    ["fab", "cc-apple-pay"],
    ["fab", "cc-diners-club"],
    ["fab", "cc-discover"],
    ["fab", "cc-jcb"],
    ["fab", "cc-mastercard"],
    ["fab", "cc-paypal"],
    ["fab", "cc-stripe"],
    ["fab", "cc-visa"],
    ["fab", "centercode"],
    ["fab", "centos"],
    ["fab", "chrome"],
    ["fab", "chromecast"],
    ["fab", "cloudscale"],
    ["fab", "cloudsmith"],
    ["fab", "cloudversify"],
    ["fab", "codepen"],
    ["fab", "codiepie"],
    ["fab", "confluence"],
    ["fab", "connectdevelop"],
    ["fab", "contao"],
    ["fab", "cotton-bureau"],
    ["fab", "cpanel"],
    ["fab", "creative-commons"],
    ["fab", "creative-commons-by"],
    ["fab", "creative-commons-nc"],
    ["fab", "creative-commons-nc-eu"],
    ["fab", "creative-commons-nc-jp"],
    ["fab", "creative-commons-nd"],
    ["fab", "creative-commons-pd"],
    ["fab", "creative-commons-pd-alt"],
    ["fab", "creative-commons-remix"],
    ["fab", "creative-commons-sa"],
    ["fab", "creative-commons-sampling"],
    ["fab", "creative-commons-sampling-plus"],
    ["fab", "creative-commons-share"],
    ["fab", "creative-commons-zero"],
    ["fab", "critical-role"],
    ["fab", "css3"],
    ["fab", "css3-alt"],
    ["fab", "cuttlefish"],
    ["fab", "d-and-d"],
    ["fab", "d-and-d-beyond"],
    ["fab", "dailymotion"],
    ["fab", "dashcube"],
    ["fab", "deezer"],
    ["fab", "delicious"],
    ["fab", "deploydog"],
    ["fab", "deskpro"],
    ["fab", "dev"],
    ["fab", "deviantart"],
    ["fab", "dhl"],
    ["fab", "diaspora"],
    ["fab", "digg"],
    ["fab", "digital-ocean"],
    ["fab", "discord"],
    ["fab", "discourse"],
    ["fab", "dochub"],
    ["fab", "docker"],
    ["fab", "draft2digital"],
    ["fab", "dribbble"],
    ["fab", "dribbble-square"],
    ["fab", "dropbox"],
    ["fab", "drupal"],
    ["fab", "dyalog"],
    ["fab", "earlybirds"],
    ["fab", "ebay"],
    ["fab", "edge"],
    ["fab", "edge-legacy"],
    ["fab", "elementor"],
    ["fab", "ello"],
    ["fab", "ember"],
    ["fab", "empire"],
    ["fab", "envira"],
    ["fab", "erlang"],
    ["fab", "ethereum"],
    ["fab", "etsy"],
    ["fab", "evernote"],
    ["fab", "expeditedssl"],
    ["fab", "facebook"],
    ["fab", "facebook-f"],
    ["fab", "facebook-messenger"],
    ["fab", "facebook-square"],
    ["fab", "fantasy-flight-games"],
    ["fab", "fedex"],
    ["fab", "fedora"],
    ["fab", "figma"],
    ["fab", "firefox"],
    ["fab", "firefox-browser"],
    ["fab", "first-order"],
    ["fab", "first-order-alt"],
    ["fab", "firstdraft"],
    ["fab", "flickr"],
    ["fab", "flipboard"],
    ["fab", "fly"],
    ["fab", "font-awesome"],
    ["fab", "font-awesome-alt"],
    ["fab", "font-awesome-flag"],
    ["fab", "font-awesome-logo-full"],
    ["fab", "fonticons"],
    ["fab", "fonticons-fi"],
    ["fab", "fort-awesome"],
    ["fab", "fort-awesome-alt"],
    ["fab", "forumbee"],
    ["fab", "foursquare"],
    ["fab", "free-code-camp"],
    ["fab", "freebsd"],
    ["fab", "fulcrum"],
    ["fab", "galactic-republic"],
    ["fab", "galactic-senate"],
    ["fab", "get-pocket"],
    ["fab", "gg"],
    ["fab", "gg-circle"],
    ["fab", "git"],
    ["fab", "git-alt"],
    ["fab", "git-square"],
    ["fab", "github"],
    ["fab", "github-alt"],
    ["fab", "github-square"],
    ["fab", "gitkraken"],
    ["fab", "gitlab"],
    ["fab", "gitter"],
    ["fab", "glide"],
    ["fab", "glide-g"],
    ["fab", "gofore"],
    ["fab", "goodreads"],
    ["fab", "goodreads-g"],
    ["fab", "google"],
    ["fab", "google-drive"],
    ["fab", "google-pay"],
    ["fab", "google-play"],
    ["fab", "google-plus"],
    ["fab", "google-plus-g"],
    ["fab", "google-plus-square"],
    ["fab", "google-wallet"],
    ["fab", "gratipay"],
    ["fab", "grav"],
    ["fab", "gripfire"],
    ["fab", "grunt"],
    ["fab", "gulp"],
    ["fab", "hacker-news"],
    ["fab", "hacker-news-square"],
    ["fab", "hackerrank"],
    ["fab", "hips"],
    ["fab", "hire-a-helper"],
    ["fab", "hooli"],
    ["fab", "hornbill"],
    ["fab", "hotjar"],
    ["fab", "houzz"],
    ["fab", "html5"],
    ["fab", "hubspot"],
    ["fab", "ideal"],
    ["fab", "imdb"],
    ["fab", "instagram"],
    ["fab", "instagram-square"],
    ["fab", "intercom"],
    ["fab", "internet-explorer"],
    ["fab", "invision"],
    ["fab", "ioxhost"],
    ["fab", "itch-io"],
    ["fab", "itunes"],
    ["fab", "itunes-note"],
    ["fab", "java"],
    ["fab", "jedi-order"],
    ["fab", "jenkins"],
    ["fab", "jira"],
    ["fab", "joget"],
    ["fab", "joomla"],
    ["fab", "js"],
    ["fab", "js-square"],
    ["fab", "jsfiddle"],
    ["fab", "kaggle"],
    ["fab", "keybase"],
    ["fab", "keycdn"],
    ["fab", "kickstarter"],
    ["fab", "kickstarter-k"],
    ["fab", "korvue"],
    ["fab", "laravel"],
    ["fab", "lastfm"],
    ["fab", "lastfm-square"],
    ["fab", "leanpub"],
    ["fab", "less"],
    ["fab", "line"],
    ["fab", "linkedin"],
    ["fab", "linkedin-in"],
    ["fab", "linode"],
    ["fab", "linux"],
    ["fab", "lyft"],
    ["fab", "magento"],
    ["fab", "mailchimp"],
    ["fab", "mandalorian"],
    ["fab", "markdown"],
    ["fab", "mastodon"],
    ["fab", "maxcdn"],
    ["fab", "mdb"],
    ["fab", "medapps"],
    ["fab", "medium"],
    ["fab", "medium-m"],
    ["fab", "medrt"],
    ["fab", "meetup"],
    ["fab", "megaport"],
    ["fab", "mendeley"],
    ["fab", "microblog"],
    ["fab", "microsoft"],
    ["fab", "mix"],
    ["fab", "mixcloud"],
    ["fab", "mixer"],
    ["fab", "mizuni"],
    ["fab", "modx"],
    ["fab", "monero"],
    ["fab", "napster"],
    ["fab", "neos"],
    ["fab", "nimblr"],
    ["fab", "node"],
    ["fab", "node-js"],
    ["fab", "npm"],
    ["fab", "ns8"],
    ["fab", "nutritionix"],
    ["fab", "odnoklassniki"],
    ["fab", "odnoklassniki-square"],
    ["fab", "old-republic"],
    ["fab", "opencart"],
    ["fab", "openid"],
    ["fab", "opera"],
    ["fab", "optin-monster"],
    ["fab", "orcid"],
    ["fab", "osi"],
    ["fab", "page4"],
    ["fab", "pagelines"],
    ["fab", "palfed"],
    ["fab", "patreon"],
    ["fab", "paypal"],
    ["fab", "penny-arcade"],
    ["fab", "periscope"],
    ["fab", "phabricator"],
    ["fab", "phoenix-framework"],
    ["fab", "phoenix-squadron"],
    ["fab", "php"],
    ["fab", "pied-piper"],
    ["fab", "pied-piper-alt"],
    ["fab", "pied-piper-hat"],
    ["fab", "pied-piper-pp"],
    ["fab", "pied-piper-square"],
    ["fab", "pinterest"],
    ["fab", "pinterest-p"],
    ["fab", "pinterest-square"],
    ["fab", "playstation"],
    ["fab", "product-hunt"],
    ["fab", "pushed"],
    ["fab", "python"],
    ["fab", "qq"],
    ["fab", "quinscape"],
    ["fab", "quora"],
    ["fab", "r-project"],
    ["fab", "raspberry-pi"],
    ["fab", "ravelry"],
    ["fab", "react"],
    ["fab", "reacteurope"],
    ["fab", "readme"],
    ["fab", "rebel"],
    ["fab", "red-river"],
    ["fab", "reddit"],
    ["fab", "reddit-alien"],
    ["fab", "reddit-square"],
    ["fab", "redhat"],
    ["fab", "renren"],
    ["fab", "replyd"],
    ["fab", "researchgate"],
    ["fab", "resolving"],
    ["fab", "rev"],
    ["fab", "rocketchat"],
    ["fab", "rockrms"],
    ["fab", "rust"],
    ["fab", "safari"],
    ["fab", "salesforce"],
    ["fab", "sass"],
    ["fab", "schlix"],
    ["fab", "scribd"],
    ["fab", "searchengin"],
    ["fab", "sellcast"],
    ["fab", "sellsy"],
    ["fab", "servicestack"],
    ["fab", "shirtsinbulk"],
    ["fab", "shopify"],
    ["fab", "shopware"],
    ["fab", "simplybuilt"],
    ["fab", "sistrix"],
    ["fab", "sith"],
    ["fab", "sketch"],
    ["fab", "skyatlas"],
    ["fab", "skype"],
    ["fab", "slack"],
    ["fab", "slack-hash"],
    ["fab", "slideshare"],
    ["fab", "snapchat"],
    ["fab", "snapchat-ghost"],
    ["fab", "snapchat-square"],
    ["fab", "soundcloud"],
    ["fab", "sourcetree"],
    ["fab", "speakap"],
    ["fab", "speaker-deck"],
    ["fab", "spotify"],
    ["fab", "squarespace"],
    ["fab", "stack-exchange"],
    ["fab", "stack-overflow"],
    ["fab", "stackpath"],
    ["fab", "staylinked"],
    ["fab", "steam"],
    ["fab", "steam-square"],
    ["fab", "steam-symbol"],
    ["fab", "sticker-mule"],
    ["fab", "strava"],
    ["fab", "stripe"],
    ["fab", "stripe-s"],
    ["fab", "studiovinari"],
    ["fab", "stumbleupon"],
    ["fab", "stumbleupon-circle"],
    ["fab", "superpowers"],
    ["fab", "supple"],
    ["fab", "suse"],
    ["fab", "swift"],
    ["fab", "symfony"],
    ["fab", "teamspeak"],
    ["fab", "telegram"],
    ["fab", "telegram-plane"],
    ["fab", "tencent-weibo"],
    ["fab", "the-red-yeti"],
    ["fab", "themeco"],
    ["fab", "themeisle"],
    ["fab", "think-peaks"],
    ["fab", "tiktok"],
    ["fab", "trade-federation"],
    ["fab", "trello"],
    ["fab", "tripadvisor"],
    ["fab", "tumblr"],
    ["fab", "tumblr-square"],
    ["fab", "twitch"],
    ["fab", "twitter"],
    ["fab", "twitter-square"],
    ["fab", "typo3"],
    ["fab", "uber"],
    ["fab", "ubuntu"],
    ["fab", "uikit"],
    ["fab", "umbraco"],
    ["fab", "uniregistry"],
    ["fab", "unity"],
    ["fab", "unsplash"],
    ["fab", "untappd"],
    ["fab", "ups"],
    ["fab", "usb"],
    ["fab", "usps"],
    ["fab", "ussunnah"],
    ["fab", "vaadin"],
    ["fab", "viacoin"],
    ["fab", "viadeo"],
    ["fab", "viadeo-square"],
    ["fab", "viber"],
    ["fab", "vimeo"],
    ["fab", "vimeo-square"],
    ["fab", "vimeo-v"],
    ["fab", "vine"],
    ["fab", "vk"],
    ["fab", "vnv"],
    ["fab", "vuejs"],
    ["fab", "waze"],
    ["fab", "weebly"],
    ["fab", "weibo"],
    ["fab", "weixin"],
    ["fab", "whatsapp"],
    ["fab", "whatsapp-square"],
    ["fab", "whmcs"],
    ["fab", "wikipedia-w"],
    ["fab", "windows"],
    ["fab", "wix"],
    ["fab", "wizards-of-the-coast"],
    ["fab", "wolf-pack-battalion"],
    ["fab", "wordpress"],
    ["fab", "wordpress-simple"],
    ["fab", "wpbeginner"],
    ["fab", "wpexplorer"],
    ["fab", "wpforms"],
    ["fab", "wpressr"],
    ["fab", "xbox"],
    ["fab", "xing"],
    ["fab", "xing-square"],
    ["fab", "y-combinator"],
    ["fab", "yahoo"],
    ["fab", "yammer"],
    ["fab", "yandex"],
    ["fab", "yandex-international"],
    ["fab", "yarn"],
    ["fab", "yelp"],
    ["fab", "yoast"],
    ["fab", "youtube"],
    ["fab", "youtube-square"],
    ["fab", "zhihu"],
  ];

  export default iconList;